export const wsMixin = {
  data() {
    return {
      isLeave: false,
      wsOpen: false,
      ws: null,
      wsTime: null,
      resetTime: null,
      hidden: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    lookActionId() {
      return this.$store.state.activePlay.lookActionId
    },
    isLive() {
      return this.$store.state.activePlay.video.isLive
    }
  },
  methods: {
    handleCloseWs() {
      this.ws.close()
    },
    resetWs() {
      clearTimeout(this.resetTime)
      // 必须在当前播放详情页面上才能执行重连WS操作
      console.log('this.$route.name', this.$route.name)
      if (this.$route.name === 'play-page' && !this.hidden) {
        this.resetTime = window.setTimeout(() => {
          this.initWs()
        }, 5000)
      }
    },
    initWs() {
      const token = localStorage.getItem('Authorization') || `guest_${+new Date()}`
      clearTimeout(this.resetTime)
      this.ws && this.ws.close()
      this.ws = new WebSocket(`${this.websocketURL}/${this.$route.params.id}/${token}`)
      this.ws.onopen = this.onopen
      this.ws.onmessage = this.receiveMsg
      this.ws.onerror = () => {
        console.log('连接失败,正在重连...')
        this.resetWs()
      }
      this.ws.onclose = () => {
        console.log('通讯连接已关闭, 需要重新刷新连接')
        this.resetWs()
      }
      /* 重连 */
      // this.ws.onclose = e => {
      //   if (this.linkCount <= 3 && !this.isLeave) {
      //     this.initWs()
      //     this.linkCount += 1
      //   }
      // }
      // this.$store.commit('initWs', this.ws)
    },
    onopen() {
      this.wsOpen = true
      clearInterval(this.wsTime)
      clearInterval(this.resetTime)
      // 设置心跳保活
      this.xtMsg(this.userInfo.id)
      this.wsTime = window.setInterval(() => {
        console.log('this.isLive', this.isLive)
        if (this.isLive) {
          console.log('mainVideoElement', this.mainVideoElement)
          const currentTime = this.mainVideoElement.currentTime
          if (this.mainVideoElement && !this.mainVideoElement.paused) {
            this.computedTimeUpdate(this.mainVideoElement, currentTime).then(res => {
              this.xtMsg(res)
            })
          } else {
            this.xtMsg(this.userInfo.id)
          }
        } else if (!this.isLive) {
          console.log('videoElement', this.videoElement)
          const currentTime = this.videoElement.currentTime
          if (this.videoElement && !this.videoElement.paused) {
            this.computedTimeUpdate(this.videoElement, currentTime).then(res => {
              this.xtMsg(res)
            })
          } else {
            this.xtMsg(this.userInfo.id)
          }
        }
      }, 1000 * 50)
    },
    computedTimeUpdate(videoEle, currentTime) {
      return new Promise(resolve => {
        videoEle.ontimeupdate = () => {
          if (currentTime === videoEle.currentTime) {
            resolve('')
          } else if (videoEle && videoEle.readyState === 4 && !videoEle.paused) {
            console.log('this.isLive', this.isLive)
            if (this.isLive) {
              resolve(this.userInfo.id + '_1')
            } else {
              resolve(this.userInfo.id + '_2')
            }
          } else {
            resolve('')
          }
        }
      })
    },
    xtMsg(i) {
      // const looking = this.mainVideoElement.paused ? 2 : 1
      const obj = {
        c: 1001,
        d: {
          r: this.id ? this.id : '', // 活动id
          n: this.userInfo.name ? this.userInfo.name : '', // 聊天人用户名
          i: i, // 用户人id
          f: '', // 活动头像
          m: '', // 聊天内容
          t: '', // 发送时间
          u: this.lookActionId
        }
      }
      if (this.ws.readyState === this.ws.OPEN) {
        this.ws.send(JSON.stringify(obj))
      }
    },
    handleClearStatus() {
      this.ws && this.ws.close()
      this.ws = null
      clearTimeout(this.resetTime)
      clearInterval(this.wsTime)
    },
    handleCisibilitychange() {
      if (document.hidden) {
        console.log('我退出了')
        this.hidden = true
        this.handleClearStatus()
      } else {
        console.log('我进来了')
        this.hidden = false
        this.initWs()
      }
    }
  },
  created() {
    this.initWs()
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleCisibilitychange, true)
  },
  beforeDestroy() {
    this.isLeave = true
    this.handleClearStatus()
    document.removeEventListener('visibilitychange', this.handleCisibilitychange, true)
    // if (this.wsTime) {
    //   clearInterval(this.wsTime)
    // }
    // if (this.resetTime) {
    //   clearInterval(this.resetTime)
    // }
    // if (this.ws && this.ws.close) {
    //   this.ws.close()
    //   this.ws = null
    // }
    // this.$store.commit('initWs', null)
  }
}
